<template>
  <div class="customer-page">
    <customer-header :name="nameRestaurant" back allergens @allergens="dialogAlergenos = true" />
    <main class="customer-content">
      <h1 class="page-title">Nuestros menús</h1>
      <p v-if="loading" class="customer-state" role="status">Cargando menús…</p>
      <div v-else-if="error" class="customer-state" role="alert">{{ error }} <el-button class="customer-retry" icon="el-icon-refresh" @click="loadData">Reintentar</el-button></div>
      <el-collapse v-else class="customer-collapse">
        <el-collapse-item v-for="menu in visibleMenus" :key="menu.key" :name="menu.key">
          <template slot="title"><div class="menu-heading"><span>{{ menu.name }}</span><span class="menu-price notranslate">{{ menuPrice(menu) }} €</span></div></template>
          <p v-if="menu.description" class="menu-description">{{ menu.description }}</p>
          <section v-for="group in menu.groups" :key="group.key" class="menu-family">
            <h2 class="family-title"><img v-if="familyIcon(group.keyOriginal)" :src="familyIcon(group.keyOriginal)" class="family-icon" alt="" />{{ familyName(group.keyOriginal) }}</h2>
            <div class="dish-grid"><dish-card v-for="dish in familyDishes(group)" :key="dish.key" :dish="dish" :allergens="alergenos" :show-price="false" /></div>
            <p v-if="!familyDishes(group).length" class="customer-state">Consulta los platos disponibles al personal del restaurante.</p>
          </section>
        </el-collapse-item>
      </el-collapse>
      <p v-if="!loading && !error && !visibleMenus.length" class="customer-state">No hay menús disponibles en este momento.</p>
    </main>
    <allergen-dialog v-model="dialogAlergenos" :allergens="alergenos" />
  </div>
</template>
<script>
import {productPrice} from '../pricing';
import * as api from "../api/request";
import CustomerHeader from "../components/CustomerHeader.vue";
import DishCard from "../components/DishCard.vue";
import AllergenDialog from "../components/AllergenDialog.vue";
export default {
  components: { CustomerHeader, DishCard, AllergenDialog },
  data() { return { nameRestaurant: "", logo: "", data: [], groups: [], alergenos: [], dialogAlergenos: false, loading: true, error: "", enableMenu: false }; },
  computed: { visibleMenus() { return this.enableMenu ? this.data.filter(menu => menu.enable === true) : []; } },
  mounted() { this.loadData(); },
  methods: {
    menuPrice(menu){const price=Number(productPrice(menu));return Number.isFinite(price)?price.toLocaleString("es-ES",{minimumFractionDigits:2,maximumFractionDigits:2}):menu.price;},
    familyIcon(key){const group=this.groups.find(g=>g.key===key);return group ? api.imageUrl(group.iconImage) : "";},
    familyName(key) { const group = this.groups.find(group => group.key === key); return group ? group.name : "Platos"; },
    familyDishes(ref) {
      const group = this.groups.find(group => group.key === ref.keyOriginal);
      return group ? (ref.plu || []).map(key => group.plu.find(dish => dish.key === key)).filter(dish => dish && dish.enable !== false) : [];
    },
    async loadData() {
      this.loading = true; this.error = "";
      try {
        const data = await api.carta();
        this.nameRestaurant = data.nameRestaurant; this.enableMenu = data.enableMenu === true;
        this.logo = api.imageUrl(data.logo);
        this.data = data.menu && data.menu.menus || []; this.groups = data.menu && data.menu.grupos || [];
        this.alergenos = await api.getAlergenos();
      } catch (error) { this.error = "No se pudieron cargar los menús. Comprueba tu conexión."; }
      finally { this.loading = false; }
    }
  }
};
</script>
<style scoped>
.family-icon{width:36px;height:36px;object-fit:contain;vertical-align:middle;margin-right:12px}
.menu-heading { display: flex; align-items: baseline; justify-content: space-between; gap: 16px; width: 100%; min-width: 0; }
.menu-heading > span:first-child { overflow-wrap: anywhere; }
.menu-price { flex-shrink: 0; font-weight: 700; font-size: 17px; }
.menu-description { margin: 0; color: #687780; font-size: 14px; line-height: 1.6; }
.menu-family .family-title { padding: 14px 16px; border-left: 5px solid var(--accent); border-radius: 0 10px 10px 0; background: var(--soft); font-size: clamp(20px, 4vw, 24px); font-weight: 700; line-height: 1.4; }
</style>
